import EmblaCarousel from "embla-carousel";
import AutoScroll from "embla-carousel-auto-scroll";

var REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var RESIZE_DEBOUNCE_MS = 100;
var TRACK_FIT_TOLERANCE_PX = 2;

/** Left edge of leftmost visible logo vs layout (px); null if no slides. */
function measureLogotypesTitleOffsetPx(viewport, container, layout) {
  var slides = container.querySelectorAll(".logotypes-wrap__slide");
  if (!slides.length) {
    return null;
  }
  var vr = viewport.getBoundingClientRect();
  var minLeft = Infinity;
  var i;
  for (i = 0; i < slides.length; i++) {
    var el = slides[i].querySelector("img") || slides[i];
    var r = el.getBoundingClientRect();
    if (r.right > vr.left && r.left < vr.right) {
      minLeft = Math.min(minLeft, r.left);
    }
  }
  if (minLeft === Infinity) {
    var fb = slides[0].querySelector("img") || slides[0];
    minLeft = fb.getBoundingClientRect().left;
  }
  var off = Math.round(minLeft - layout.getBoundingClientRect().left);
  return off < 0 ? 0 : off;
}

function initLogotypesEmbla(root) {
  var viewport = root.querySelector(".logotypes-wrap__viewport");
  var container = root.querySelector(".logotypes-wrap__container");
  if (!viewport || !container) {
    return function noop() {};
  }

  if (container.querySelectorAll(".logotypes-wrap__slide").length < 2) {
    return function noop() {};
  }

  var embla = null;
  var mqReduced = window.matchMedia(REDUCED_MOTION);
  var resizeTimer = null;

  function syncTitleAlign() {
    var layout = root.querySelector(".logotypes-wrap__layout");
    if (!layout || !root.querySelector(".logotypes-wrap__title")) {
      return;
    }
    var px = measureLogotypesTitleOffsetPx(viewport, container, layout);
    if (px === null) {
      layout.style.removeProperty("--logotypes-title-offset");
      return;
    }
    layout.style.setProperty("--logotypes-title-offset", px + "px");
  }

  function updateTrackFits() {
    if (mqReduced.matches || !embla) {
      root.classList.remove("logotypes-wrap--track-fits");
    } else {
      var fits =
        container.scrollWidth <= viewport.clientWidth + TRACK_FIT_TOLERANCE_PX;
      root.classList.toggle("logotypes-wrap--track-fits", fits);
    }
    syncTitleAlign();
  }

  function scheduleTrackFits() {
    if (resizeTimer) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(function () {
      resizeTimer = null;
      updateTrackFits();
    }, RESIZE_DEBOUNCE_MS);
  }

  function applyReduced() {
    if (mqReduced.matches) {
      root.classList.add("logotypes-wrap--no-motion");
      root.classList.remove("logotypes-wrap--track-fits");
      if (embla) {
        embla.off("reInit", updateTrackFits);
        embla.destroy();
        embla = null;
      }
      updateTrackFits();
      return;
    }

    root.classList.remove("logotypes-wrap--no-motion");
    if (embla) {
      return;
    }

    embla = EmblaCarousel(
      viewport,
      {
        loop: true,
        align: "start",
        dragFree: false,
      },
      [
        AutoScroll({
          speed: .8,
          startDelay: 0,
          stopOnMouseEnter: false,
          stopOnInteraction: false,
          direction: "forward",
        }),
      ]
    );
    embla.on("reInit", updateTrackFits);

    var autoScroll = embla.plugins().autoScroll;
    if (autoScroll) {
      autoScroll.play();
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(updateTrackFits);
    });
  }

  applyReduced();

  window.addEventListener("resize", scheduleTrackFits);

  container.querySelectorAll("img").forEach(function (img) {
    if (!img.complete) {
      img.addEventListener("load", updateTrackFits);
    }
  });

  if (mqReduced.addEventListener) {
    mqReduced.addEventListener("change", applyReduced);
  } else {
    mqReduced.addListener(applyReduced);
  }

  return function cleanup() {
    window.removeEventListener("resize", scheduleTrackFits);
    if (resizeTimer) {
      clearTimeout(resizeTimer);
    }
    var layout = root.querySelector(".logotypes-wrap__layout");
    if (layout) {
      layout.style.removeProperty("--logotypes-title-offset");
    }
    container.querySelectorAll("img").forEach(function (img) {
      img.removeEventListener("load", updateTrackFits);
    });
    if (mqReduced.removeEventListener) {
      mqReduced.removeEventListener("change", applyReduced);
    } else {
      mqReduced.removeListener(applyReduced);
    }
    if (embla) {
      embla.off("reInit", updateTrackFits);
      embla.destroy();
      embla = null;
    }
    root.classList.remove("logotypes-wrap--no-motion");
    root.classList.remove("logotypes-wrap--track-fits");
  };
}

document.querySelectorAll(".js-logotypes-embla").forEach(function (root) {
  initLogotypesEmbla(root);
});
